/**
 * 予約関連のStoreで使用するStateをここで定義する
 *
 * Copyright (c) 2018-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Record } from 'immutable'

const ReservationSearchState = Record({
  search_keywords: '',
  search_hotel_ids: [],
  search_hotel_options: [],
  search_start_date: null,
  search_end_date: null,
  search_status_booked: true,
  search_status_cancelled: true,
  search_status_not_a_reservation: true,
  search_noshow: false,
  search_site_referrer_ids: []
})

export { ReservationSearchState }
